import { Actualizador } from "./Actualizador";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { InvestigacionDTO } from "@DTOS";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";

export class BasicoActualizador extends Actualizador {
    constructor(private investigacionesService: InvestigacionesService) {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, _datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        return await this.investigacionesService.guardarInvestigacionNuevo(investigacion);
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return Object.keys(datos).length === 0;
    }

}
